// extracted by mini-css-extract-plugin
module.exports = {"label":"CustomerPayment_label_2sSzX","isLarge":"CustomerPayment_isLarge_1WYa4","paymentInput":"CustomerPayment_paymentInput_2XQRf","totalInput":"CustomerPayment_totalInput_2Q5Rb"};